import { SubmissionError } from 'redux-form';

export const validateSaveEditPassword = values => {
  if (!values.versionName) {
    throw new SubmissionError({
      versionName: 'Required',
      _error: 'Name the version',
    });
  }
};

export const validateForgottenPassword = values => {
  if (!values.Email) {
    throw new SubmissionError({
      Email: 'Required',
      _error: 'Invalid email address',
    });
  }
  if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.Email)) {
    throw new SubmissionError({
      Email: 'Invalid email address',
      _error: 'Invalid email address',
    });
  }
};

export const validateAddUser = values => {
  if (!values.Email) {
    throw new SubmissionError({
      Email: 'Required',
      _error: 'Invalid email address',
    });
  }
  if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.Email)) {
    throw new SubmissionError({
      Email: 'Invalid email address',
      _error: 'Invalid email address',
    });
  }
};

export const validateLogin = values => {
  if (!values.Email) {
    throw new SubmissionError({
      Email: 'Required',
      _error: 'Invalid email address',
    });
  }
  if (!values.Password) {
    throw new SubmissionError({
      Password: 'Required',
      _error: 'Invalid password',
    });
  }

  if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.Email)) {
    throw new SubmissionError({
      Email: 'Invalid email address',
      _error: 'Invalid email address',
    });
  }

  if (
    values.Password &&
    !/^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(values.Password)
  ) {
    throw new SubmissionError({
      Password:
        'Minimum eight characters, at least one letter, one number and one special character',
      _error: 'Invalid password',
    });
  }
};

export const validateRegistrationNew = values => {
  const errors = {}
  if (!values.firstName) {
    errors.firstName = 'Required'
  }
  if (!values.lastName) {
    errors.lastName = 'Required'
  }
  if (!values.email) {
    errors.email = 'Required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  return errors
};

export const validateRegistration = values => {
  console.log('COACH CODE', values.CoachCode)
  if (values.CoachCode!='CPS2020') {
    throw new SubmissionError({
      Code: 'Required',
      _error: 'Invalid code',
    });
  }
  if (!values.firstname) {
    throw new SubmissionError({
      Firstname: 'Required',
      _error: 'Invalid firstname',
    });
  }
  if (!values.lastname) {
    throw new SubmissionError({
      Lastname: 'Required',
      _error: 'Invalid lastname',
    });
  }
  if (!values.email) {
    throw new SubmissionError({
      Email: 'Required',
      _error: 'Invalid email address',
    });
  }
  if (!values.Password) {
    throw new SubmissionError({
      Password: 'Required',
      _error: 'Invalid password',
    });
  }
  if (!values.Phone) {
    throw new SubmissionError({
      Phone: 'Required',
      _error: 'Invalid phone',
    });
  }
  if (!values.Code) {
    throw new SubmissionError({
      Code: 'Required',
      _error: 'Invalid code',
    });
  }
  

  if (values.ConfirmPassword !== values.Password) {
    throw new SubmissionError({
      ConfirmPassword: 'Password mismatched',
      _error: 'Password mismatched',
    });
  }

  if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.Email)) {
    throw new SubmissionError({
      Email: 'Invalid email address',
      _error: 'Invalid email address',
    });
  }
  if (values.Code && !/.{9}/.test(values.Code)) {
    throw new SubmissionError({
      Code: 'At least 9 characters',
      _error: 'Invalid Code',
    });
  }
  if (
    values.Password &&
    !/^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(values.Password)
  ) {
    throw new SubmissionError({
      Password:
        'Minimum eight characters, at least one letter, one number and one special character',
      _error: 'Invalid password',
    });
  }
};

export const validateAddProjectCode = values => {
  if (!values.Code) {
    throw new SubmissionError({
      Code: 'Required',
      _error: 'Invalid code',
    });
  }
  if (!values.CodeConfirm) {
    throw new SubmissionError({
      CodeConfirm: 'Required',
      _error: 'Invalid code',
    });
  }

  if (values.Code && !/.{9}/.test(values.Code)) {
    throw new SubmissionError({
      Code: 'At least 9 characters',
      _error: 'Invalid Code',
    });
  }

  if (values.CodeConfirm !== values.Code) {
    throw new SubmissionError({
      CodeConfirm: 'Code mismatched',
      _error: 'Code mismatched',
    });
  }
};



// WEBPACK FOOTER //
// ./src/Components/Form/validate.jsx